import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonImg,
  IonModal,
  IonPage,
  IonProgressBar,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { useContext, useEffect, useRef, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { AppContext } from '../../../lib/context/AppContext';
import { Trip, ITrip } from '../../../lib/models';
import PageContainer from '../../../components/PageContainer';
import { closeCircleOutline } from 'ionicons/icons';
import { BsPlayCircleFill } from 'react-icons/bs';

interface TripDetailPageProps
  extends RouteComponentProps<{
    tripId: string;
  }> {}

const TripDetailsPage: React.FC<TripDetailPageProps> = ({ match }) => {
  const { apiService } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);
  const modal = useRef<HTMLIonModalElement>(null);
  const [currentMedia, setCurrentMedia] = useState<any | null>();
  const [trip, setTrip]: [ITrip | undefined, any] = useState();

  const fetchTrip = () => {
    apiService?.get(`/trips/${match.params.tripId}?populate=media,medias`).then(
      (response: any) => {
        setTrip(Trip(response.data.data));
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    if (!trip) {
      setIsLoading(true);
      fetchTrip();
    }
  }, [apiService]);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color='primary'>
          {isLoading && <IonProgressBar type='indeterminate'></IonProgressBar>}
          <IonButtons slot='start'>
            <IonBackButton
              defaultHref='/trips'
              text={'Indietro'}
            ></IonBackButton>
          </IonButtons>
          <IonTitle>Dettaglio viaggio</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {trip?.media?.data?.attributes?.url && (
          <IonImg src={trip?.media?.data?.attributes?.url}></IonImg>
        )}
        {trip && (
          <PageContainer>
            <h1 className='mt-2'>{trip?.title}</h1>
            <div className='mt-4 flex items-center'>
              <div>
                {trip?.startDate && (
                  <span>
                    Inizio:{' '}
                    <span className='font-bold'>
                      {new Date(trip?.startDate).toLocaleDateString()}
                    </span>
                  </span>
                )}
                {trip?.startDate && trip?.endDate && ' - '}
                {trip?.endDate && (
                  <span>
                    Fine:{' '}
                    <span className='font-bold'>
                      {new Date(trip?.endDate).toLocaleDateString()}
                    </span>
                  </span>
                )}
              </div>
            </div>
            <div className='border-top w-full h-[1px] bg-gray-300 my-4'></div>
            <div
              className='pb-4'
              dangerouslySetInnerHTML={{
                __html: trip?.description || '',
              }}
            ></div>
            {trip?.medias?.data?.length && (
              <div className='mt-8 grid grid-cols-2 gap-1'>
                {trip.medias?.data?.map((_media: any) => (
                  <div
                    className='relative rounded-md'
                    key={_media.attributes.url}
                  >
                    {_media.attributes.mime.includes('video') ? (
                      <div
                        onClick={() => {
                          setCurrentMedia(_media);
                        }}
                        className='w-full h-full bg-black/80 rounded-md'
                      >
                        <video
                          src={_media.attributes.url}
                          className={`object-contain object-center w-full aspect-[2/3] h-52 -z-10`}
                          autoPlay={false}
                          tabIndex={-1}
                        ></video>
                        <BsPlayCircleFill className='w-8 h-8 absolute inset-0 m-auto text-white group z-10' />
                      </div>
                    ) : (
                      <img
                        src={_media.attributes.url}
                        alt={_media.attributes.name}
                        className={`object-contain object-center w-full aspect-[2/3] h-52 rounded-md`}
                        onClick={() => {
                          setCurrentMedia(_media);
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>
            )}

            {trip.archiveLink && (
              <div className='my-4 w-full px-4'>
                <IonButton
                  color={'primary'}
                  href={trip.archiveLink}
                  target='_blank'
                  className='w-full'
                >
                  Tutte le foto
                </IonButton>
              </div>
            )}
          </PageContainer>
        )}

        <IonModal ref={modal} isOpen={!!currentMedia}>
          <IonContent fullscreen={true}>
            <IonButton
              className='w-fit fixed right-4 top-12 z-10'
              onClick={() => setCurrentMedia(null)}
            >
              <IonIcon icon={closeCircleOutline} />
            </IonButton>
            {currentMedia?.attributes?.mime?.includes('video') ? (
              <video
                src={currentMedia.attributes.url}
                className={`object-contain object-center w-full h-full -z-10`}
                autoPlay={true}
                controls={true}
              ></video>
            ) : (
              <img
                src={currentMedia?.attributes.url}
                alt={currentMedia?.attributes.name}
                className={`object-contain object-center w-full h-full -z-10`}
              />
            )}
          </IonContent>
        </IonModal>
      </IonContent>
    </IonPage>
  );
};
export default TripDetailsPage;
